import { Link } from 'react-router-dom'

interface MegaMenuProps {
  isOpen: boolean
  onClose: () => void
}

export function MegaMenu({ isOpen, onClose }: MegaMenuProps) {
  if (!isOpen) return null

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-40"
        onClick={onClose}
      />

      {/* Menu */}
      <div className="absolute top-full left-0 w-full bg-white shadow-lg border-t border-gray-200 z-50">
        <div className="container py-8">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Tools */}
            <div>
              <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
                Tools
              </h3>
              <div className="space-y-2">
                <Link
                  to="/check"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    AI Detector
                  </div>
                </Link>
                <Link
                  to="/undetectable"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    Make Undetectable
                  </div>
                </Link>
                <Link
                  to="/enhance-realism"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    Enhance Realism
                  </div>
                </Link>
                <Link
                  to="/tools/metadata-cleaner"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    Metadata Cleaner
                  </div>
                </Link>
              </div>
            </div>

            {/* Benchmark */}
            <div>
              <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
                Benchmark
              </h3>
              <div className="space-y-2">
                <Link
                  to="/"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    Detector Rankings
                  </div>
                </Link>
                <Link
                  to="/arena"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    Arena
                  </div>
                </Link>
              </div>
            </div>

            {/* Browse */}
            <div>
              <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
                Browse
              </h3>
              <div className="space-y-2">
                <Link
                  to="/watermarks"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    Watermarks
                  </div>
                </Link>
                <Link
                  to="/services"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    AI Services
                  </div>
                </Link>
                <Link
                  to="/models"
                  onClick={onClose}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                >
                  <div className="font-medium text-gray-800 group-hover:text-primary-600 text-sm">
                    AI Models
                  </div>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}
